export default __webpack_public_path__ + "static/28-c29437a9fa679688c93f232234e9b91a.png";